import { render, staticRenderFns } from "./MoreFilterItem.vue?vue&type=template&id=13e29d0d&scoped=true&"
import script from "./MoreFilterItem.vue?vue&type=script&lang=js&"
export * from "./MoreFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./MoreFilterItem.vue?vue&type=style&index=0&id=13e29d0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e29d0d",
  null
  
)

export default component.exports